<template>
  <div class="user-card" :class="{vertical}" v-if="user.id">
    <div class="user-card__profile-image" v-if="profilePicture">
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle user-card__profile-image" alt="img" :style="'display: inline-block; width: ' + (cardStyle !== 'micro' ? (profilePictureSize.indexOf('px') !== -1 ? profilePictureSize : profilePictureSize + 'px') : '25px') + '; height: ' + (cardStyle !== 'micro' ? (profilePictureSize.indexOf('px') !== -1 ? profilePictureSize : profilePictureSize + 'px') : '25px') + '; background-image: url(' + (user.profile_picture || 'https://www.gravatar.com/avatar/default?s=' + (cardStyle !== 'micro' ? profilePictureSize.replace('px', '') : '25') + '&r=pg&d=mm') + ');'" />
    </div>
    <div class="user-card__profile-data">
      <h5>
        <b-link :to="{name: 'UsersEdit', params: {id: user.id}}" target="_blank">#{{user.id}}</b-link>
        {{user.name}}
        <span v-if="isCourier && user.courier_available">
          <span v-b-tooltip.html
            :title="user.courier_available && user.courier_available.active ? $gettext('ONLINE') + (user.courier_available.tracking && user.courier_available.tracking[0] ? ' ' + $gettextInterpolate($gettext('(Last tracking sent on %{date})'), {date: moment.utc(user.courier_available.tracking[0].created_at).tz($tz).format('L LT')}) : '') : $gettext('OFFLINE')"
            style="display: inline-block; width:15px; height:15px; border-radius: 100px; vertical-align:middle;"
            :class="user.courier_available && user.courier_available.active ? 'bg-success' : 'bg-dark'"
          ></span>
          <span v-b-tooltip.html
            v-if="user.courier_available && user.courier_available.tracking && user.courier_available.tracking.length > 0"
            :title="user.courier_available && user.courier_available.tracking && user.courier_available.tracking.length > 0 ? (!user.courier_available.tracking[0].shipping_id ? $gettext('FREE') : $gettext('BUSY')) : $gettext('NO TRACKING DATA')"
            style="display: inline-block; width:15px; height:15px; border-radius: 100px; vertical-align:middle;"
            :class="user.courier_available && user.courier_available.tracking && user.courier_available.tracking.length > 0 ? (!user.courier_available.tracking[0].shipping_id ? 'bg-success' : 'bg-danger') : 'bg-dark'"
          ></span>
          <b-button pill
            v-b-tooltip.html
            :title="$gettext('Current position')"
            v-b-modal.modalTrackingMap
            style="width: 20px; height: 20px; padding: 0; vertical-align: middle; line-height: 10px;"
            v-if="withMap && user.courier_available && user.courier_available.tracking && user.courier_available.tracking.length > 0"
            size="sm"
            @click.stop="openUserMap"
          >
            <font-awesome-icon icon="map-marker-alt" size="2x" style="font-size: 10px; vertical-align: middle;" />
          </b-button>
        </span>
      </h5>
      <div v-if="cardStyle !== 'micro'">
        <span v-if="user.company" class="badge" :style="'background-color: ' + stringToColour(' ' + user.company_id + user.company_id + user.company_id + user.company_id) + ';' + textContrastColor(stringToColour(' ' + user.company_id + user.company_id + user.company_id + user.company_id))">{{user.company.name | cleanentityprefix}}</span>
        <dl class="mb-0">
          <dt v-if="withTitles" v-translate>Email</dt>
          <dd v-if="user.email">
            <a :href="'mailto:' + user.email">{{user.email}}</a>
            <a v-b-tooltip.html href="#" @click.prevent="copyToClipboard(user.email, 'email')" class="text-secondary" :title="$gettext('Copy to Clipboard')">
              <font-awesome-icon :icon="['far', 'copy']" size="1x" />
            </a>
          </dd>
          <dd class="text-danger" v-else><strong v-translate>NO EMAIL!!?? 😕</strong></dd>
          <dt v-if="withTitles" v-translate>Phone</dt>
          <dd v-if="user.phone">
            <span class="d-inline-block" v-b-tooltip.bottom.html :title="phoneActions">
              {{user.phone | phone('ar')}}
            </span>
            <a v-b-tooltip.html href="#" @click.prevent="copyToClipboard(user.phone, 'phone')" class="text-secondary" :title="$gettext('Copy to Clipboard')">
              <font-awesome-icon :icon="['far', 'copy']" size="1x" />
            </a>
          </dd>
          <dd class="text-danger" v-else><strong v-translate>NO PHONE! 😕</strong></dd>
        </dl>
      </div>
    </div>
    <b-modal v-if="withMap" id="modalUserMap" size="xl" ref="modalUserMap" @shown="addMarkers" @hide="fitAlways = false; $refs.userMap.markers = []; $refs.userMap.polyLines = []" hide-header hide-footer>
      <leaflet-map ref="userMap" style="height:80vh" :zoom="15" :centerMap="true" :fitAlways="true" :geolocate="false" />
    </b-modal>
  </div>
</template>

<script>
import ShippingsMixin from '@/mixins/shippings.mixin'
import LeafletMap from '@/components/Maps/LeafletMap'

export default {
  name: 'UsersCard',
  components: {
    LeafletMap
  },
  data() {
    return {
      markers: [],
      fitAlways: false
    }
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      },
      required: true
    },
    profilePicture: {
      type: Boolean,
      default: true
    },
    profilePictureSize: {
      type: [String, Number],
      default: '80px'
    },
    withTitles: {
      type: Boolean,
      default: true
    },
    withMap: {
      type: Boolean,
      default: true
    },
    vehicleTypesProp: {
      type: Array
    },
    vertical: {
      type: Boolean,
      default: false
    },
    cardStyle: {
      type: String,
      default: ''
    }
  },
  computed: {
    phoneActions() {
      return '<div class="m-2 text-nowrap"><a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" href="tel:' + this.user.phone + '">' + this.$gettext('Call') + '</a>&nbsp;<a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="user.phone" href="' + this.$options.filters.whatsappize(this.user.phone) + '">WhatsApp</a></div>'
    },
    isCourier() {
      return this.user.roles.findIndex(x => x.name === 'courier') !== -1
    }
  },
  mixins: [
    ShippingsMixin
  ],
  methods: {
    openUserMap() {
      const isFree = this.user.courier_available.tracking[0].shipping_id === null || this.user.courier_available.tracking[0].shipping_id === '' ? 'blue' : 'gray'

      const icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-' + this.vehicleTypes.find(x => x.id === this.user.courier_available.vehicle_type_id).name.toLowerCase() + '-' + isFree + '.svg'

      const infoWindowHtml = '<div>Last tracking sent on: <strong>' + (this.user.courier_available.tracking[0] ? this.moment.utc(this.user.courier_available.tracking[0].created_at).tz(this.$tz).format('L LT') : 'NO DATA') + '</strong></div>'
      this.markers = []

      if (this.user.courier_available.tracking.length > 0) {
        this.markers.push({
          id: 0,
          lat: this.user.courier_available.tracking[0].lat,
          lng: this.user.courier_available.tracking[0].lng,
          icon,
          x: 25,
          y: 25,
          infoText: infoWindowHtml,
          tooltip: true
        })
      }
      this.$refs.modalUserMap.show()
    },
    addMarkers() {
      let mark = 0
      let id = 0
      const currentShippings = this.user.courier_available.tracking.map(x => { return x.shipping_id })
      if (currentShippings.length > 0) {
        const params = {
          includes: ['status_history'],
          filter_groups: [
            {
              filters: [
                ['id', 'in', currentShippings]
              ]
            }
          ]
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings', { params })
          .then(response => {
            response.body.data.forEach((shipping, i) => {
              const infoWindowHtml = this.formatShippingPopup(shipping)
              mark++
              id++
              this.markers.push({
                id,
                lat: shipping.address_to.lat,
                lng: shipping.address_to.lng,
                icon: {
                  type: 'map-marker',
                  size: [27, 36],
                  anchor: [18, 39],
                  color: '#cccccc',
                  text: mark + '↓'
                },
                x: 13,
                y: 44,
                infoText: { id: shipping.id, type: 'shipping', html: infoWindowHtml, ids: [shipping.id] },
                popup: true
              })
              id++
              this.markers.push({
                id,
                lat: shipping.address_from.lat,
                lng: shipping.address_from.lng,
                icon: {
                  type: 'map-marker',
                  size: [27, 36],
                  anchor: [18, 39],
                  color: '#999999',
                  text: mark + '↑'
                },
                x: 13,
                y: 44,
                infoText: { id: shipping.id, type: 'shipping', html: infoWindowHtml, ids: [shipping.id] },
                popup: true
              })
              this.fitAlways = true

              this.$refs.userMap.addMarkers(this.markers)
            })
          })
      }
      this.$refs.userMap.addMarkers(this.markers)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-card {
  display: flex;
  &.vertical {
    flex-direction: column;
    .user-card__profile-image {
      padding-right: 0;
      padding-bottom: 15px;
    }
  }
  &__profile-image {
    background: transparent no-repeat 50% 50%/cover;
    padding-right: 15px;
  }
  &__profile-data {
    flex: 1 1 auto;
    h5 {
      font-weight: 400;
      white-space: nowrap;
      margin-bottom: 0;
      font-size: 1.2em;
    }
    dl {
      font-size: 1em;
    }
    dt {
      width: 70px;
      font-weight: 400;
      float: left;
    }
    dd {
      font-weight: 400;
      margin: 0;
      white-space: nowrap;
    }
  }
  &__profile-phone {
    background: transparent;
    border: 0;
  }
}
</style>
